package antd.menu

import kotlinext.js.jsObject
import react.RBuilder
import react.RHandler
import react.RProps

fun RBuilder.menu(handler: RHandler<MenuProps>) = child(MenuComponent::class, handler)
fun RBuilder.menuItem(handler: RHandler<MenuItemProps>) = child(MenuItemComponent::class, handler)
fun RBuilder.subMenu(handler: RHandler<SubMenuProps>) = child(SubMenuComponent::class, handler)
fun RBuilder.menuItemGroup(handler: RHandler<MenuItemGroupProps>) = child(MenuItemGroupComponent::class, handler)
fun RBuilder.menuDivider(handler: RHandler<RProps>) = child(MenuDividerComponent::class, handler)
